import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d56e6d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "bookmarks" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Bookmark list is empty", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Add a Bookmark ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bookmark_item = _resolveComponent("bookmark-item")!
  const _component_my_button = _resolveComponent("my-button")!

  return (_openBlock(), _createBlock(_Transition, { name: "fade-list" }, {
    default: _withCtx(() => [
      (_ctx.bookmarks.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bookmarks, (bookmark) => {
                return (_openBlock(), _createBlock(_component_bookmark_item, {
                  key: bookmark.createdAt,
                  bookmark: bookmark
                }, null, 8, ["bookmark"]))
              }), 128))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createVNode(_component_my_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('bookmark'))),
              class: "margin__top__20"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]))
    ]),
    _: 1
  }))
}